<template>
  <el-upload
    class="avatar-uploader"
    action="/forum-pub-api/v1/file/upload"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    name="file_name"
  >
    <img
      v-if="value"
      :key="value"
      :src="'/forum-pub-api/v1/minio/getFile?file_url=' + value"
      class="avatar"
    />
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
export default {
  props: { value: null },
  methods: {
    handleAvatarSuccess(response) {
      this.$emit('input', response);
      // this.registration_info_item.paymentInfo.payment_result_screenshot = response;
    },
  },
};
</script>
